
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeMotorBoatFilled as ObiVesselTypeMotorBoatFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-motor-boat-filled.js';
 
 
 

 
 export const ObiVesselTypeMotorBoatFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-motor-boat-filled',
   elementClass: ObiVesselTypeMotorBoatFilledElement,
   events: {
     
   }
  });
 
 